import Head from 'next/head'
import Image from 'next/image'
import tutorBusiness from '../public/images/tutor_business.svg'
import tutorControlSchedule from '../public/images/tutor_control_schedule.svg'
import tutorRevenue from '../public/images/tutor_revenue.svg'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import BecomeATutorHero from '../components/BecomeATutorHero'

export default function BecomeATutor() {
  return <>
    <Head>
      <title>Become a Tutor | Tutorspot</title>
    </Head>
    <BecomeATutorHero />
    <Container>
      <Row className="mt-5 text-center">
        <Col xs={12} md={4}>
          <div className="p-4">
            <Image
              src={tutorBusiness}
              width={300}
              height={200}
              style={{
                maxWidth: "100%",
                height: "auto"
              }} />

            <div className="mt-5">
              <h4>Build Your Tutoring Business</h4>
              <p className="text-secondary">We will advertise your profile so potential students can message you</p>
            </div>
          </div>
        </Col>
        <Col xs={12} md={4}>
          <div className="p-4">
            <Image
              src={tutorControlSchedule}
              width={300}
              height={200}
              style={{
                maxWidth: "100%",
                height: "auto"
              }} />

            <div className="mt-5">
              <h4>Be in Control</h4>
              <p className="text-secondary">Choose the subjects you tutor and your rate according to your qualifications
                and experience</p>
            </div>
          </div>
        </Col>
        <Col xs={12} md={4}>
          <div className="p-4">
            <Image
              src={tutorRevenue}
              width={300}
              height={200}
              style={{
                maxWidth: "100%",
                height: "auto"
              }} />

            <div className="mt-5">
              <h4>Easy, Straightforward Payments</h4>
              <p className="text-secondary">We pay you weekly for all of your lessons so you can focus on your
                students</p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </>
}
